import { Burger, Center, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLogout, IconSwitchHorizontal } from "@tabler/icons-react";
import { useContext, useState, useEffect } from "react";

import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { LogoSmall } from "../../Lib/data";
import { RouteList } from "../../Lib/routes";
import "./styles.scss";
import { AppContext } from "../../Pages/Dashboard";
import MegaLoader from "../MegaLoader";
const Navbar: React.FC = () => {
  const context = useContext(AppContext);
  const location = useLocation();
  const [active, setActive] = useState("");

  const [isNavOpen, { toggle: toggleNav, close: closeNav }] =
    useDisclosure(false);
  const scopes = context?.profile?.scopes ?? [];
  const routes =
    context?.profile?.role === "superadmin"
      ? RouteList
      : RouteList.filter((route) => {
          return route.scopes.some((scope) => scopes.includes(scope));
        });

  // Update active state based on current location
  useEffect(() => {
    const currentRoute = RouteList.find(
      (route) => route.path === location.pathname
    );
    if (currentRoute) {
      setActive(currentRoute.label);
    } else {
      // Handle special cases like course detail pages
      if (location.pathname.startsWith("/d/course/")) {
        setActive("Courses");
      } else if (
        location.pathname.startsWith("/d/blog-edit/") ||
        location.pathname.startsWith("/d/blog-view/")
      ) {
        setActive("Blogs");
      } else if (location.pathname === "/d") {
        setActive("Overview");
      } else {
        setActive("Overview"); // Default to Overview
      }
    }
  }, [location.pathname]);
  const links = routes.map((route) => (
    <Link
      className={"link"}
      style={{
        display: isNavOpen ? "flex" : "none",
      }}
      data-active={route.label === active || undefined}
      to={route.path}
      key={route.label}
      onClick={(event) => {
        closeNav();
      }}
    >
      <route.icon className={"linkIcon"} stroke={1.5} />
      <motion.span
        initial={false}
        animate={{
          opacity: isNavOpen ? 1 : 0,
          display: isNavOpen ? "block" : "none",
        }}
        transition={{ duration: 0.3 }}
      >
        {route.label}
      </motion.span>
    </Link>
  ));

  return (
    <>
      <motion.nav
        className="navbar-container"
        initial={{ x: -340 }}
        animate={{ x: isNavOpen ? 0 : -280 }}
        transition={{ duration: 0.3 }}
      >
        <div className={"navbarMain"}>
          <Group className={"header"} justify="space-between">
            <img src={LogoSmall} className="logo" />
            <Burger size={21} opened={isNavOpen} onClick={toggleNav} />
          </Group>
          {context?.isLoadingProfile ? (
            <Center w="100%" mt={100}>
              <MegaLoader />
            </Center>
          ) : (
            <div className="flex-col links">{links}</div>
          )}
        </div>

        <motion.div
          initial={false}
          animate={{
            opacity: isNavOpen ? 1 : 0,
            display: isNavOpen ? "block" : "none",
          }}
          transition={{ duration: 0.3 }}
          className={"footer"}
        >
          <a
            href="#"
            className={"link"}
            onClick={(event) => {
              event.preventDefault();
              context?.logout();
            }}
          >
            <IconLogout className={"linkIcon"} stroke={1.5} />
            <span>Logout</span>
          </a>
        </motion.div>
      </motion.nav>
      <div className="nav-placeholder"></div>
    </>
  );
};
export default Navbar;
